import { motion } from "framer-motion";
import { PackageCheck, Globe, FlaskConical, Headset } from "lucide-react";

const features = [
  { icon: PackageCheck, title: "Discreet Packaging", sub: "100% private & secure" },
  { icon: Globe, title: "Worldwide Shipping", sub: "Fast & reliable delivery" },
  { icon: FlaskConical, title: "Lab Verified", sub: "Purity guaranteed" },
  { icon: Headset, title: "Dedicated Support", sub: "Here to help you" },
];

export const Features = () => {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12" data-testid="features-section">
      <div className="max-w-[1600px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map((f, i) => (
          <motion.div
            key={f.title}
            initial={{ opacity: 0, y: 25 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="rounded-xl border border-[#29FF87]/20 bg-[#0B120B] p-8 hover:border-[#29FF87]/50 transition-colors duration-300 group"
            data-testid={`feature-${i}`}
          >
            <span className="h-12 w-12 rounded-full border border-[#29FF87]/40 flex items-center justify-center text-[#29FF87] group-hover:glow-box transition-shadow">
              <f.icon size={20} strokeWidth={1.6} />
            </span>
            <h3 className="mt-6 font-grotesk font-bold uppercase tracking-[0.1em] text-white text-sm">{f.title}</h3>
            <p className="mt-1 font-body text-xs uppercase tracking-[0.15em] text-[#7BC79A]">{f.sub}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
